import { Input } from "@/components/ui/input";
import { monthOptions } from "@/lib/format";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const todayWib = () => new Date(Date.now() + 7 * 3600 * 1000).toISOString().slice(0, 10);

export function periodQuery({ period, date, date_from, date_to }) {
  const p = new URLSearchParams({ period });
  if (period === "CUSTOM") {
    if (date_from) p.append("date_from", date_from);
    if (date_to) p.append("date_to", date_to);
  } else if (date) {
    p.append("date", period === "BULANAN" ? `${date.slice(0, 7)}-01` : date);
  }
  return p.toString();
}

export function weekRange(dateStr) {
  const d = new Date(dateStr + "T00:00:00Z");
  const dow = (d.getUTCDay() + 6) % 7;
  const start = new Date(d); start.setUTCDate(d.getUTCDate() - dow);
  const end = new Date(start); end.setUTCDate(start.getUTCDate() + 6);
  return [start.toISOString().slice(0, 10), end.toISOString().slice(0, 10)];
}

export default function PeriodPicker({ value, onChange, testId = "period", allowCustom = false }) {
  const { period, date } = value;
  const months = monthOptions(12);
  const curYear = Number(todayWib().slice(0, 4));
  const years = Array.from({ length: 6 }, (_, i) => String(curYear - i));
  const set = (patch) => onChange({ ...value, ...patch });
  const firstOfMonth = `${todayWib().slice(0, 7)}-01`;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-picker`}>
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Periode</span>
        <Select value={period} onValueChange={(p) => set({
          period: p,
          date: p === "BULANAN" ? todayWib() : p === "TAHUNAN" ? `${curYear}-01-01` : date || todayWib(),
          ...(p === "CUSTOM" ? { date_from: value.date_from || firstOfMonth, date_to: value.date_to || todayWib() } : {}),
        })}>
          <SelectTrigger className="w-36 h-9" data-testid={`${testId}-select`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="HARIAN" data-testid={`${testId}-harian`}>HARIAN</SelectItem>
            <SelectItem value="MINGGUAN" data-testid={`${testId}-mingguan`}>MINGGUAN</SelectItem>
            <SelectItem value="BULANAN" data-testid={`${testId}-bulanan`}>BULANAN</SelectItem>
            <SelectItem value="TAHUNAN" data-testid={`${testId}-tahunan`}>TAHUNAN</SelectItem>
            {allowCustom && <SelectItem value="CUSTOM" data-testid={`${testId}-custom`}>CUSTOM</SelectItem>}
          </SelectContent>
        </Select>
      </div>
      {period === "CUSTOM" ? (
        <div className="flex items-center gap-2">
          <Input type="date" className="w-40 h-9" value={value.date_from || firstOfMonth} max={value.date_to || undefined}
            onChange={(e) => e.target.value && set({ date_from: e.target.value })} data-testid={`${testId}-date-from`} />
          <span className="text-xs text-slate-500">s/d</span>
          <Input type="date" className="w-40 h-9" value={value.date_to || todayWib()} min={value.date_from || undefined}
            onChange={(e) => e.target.value && set({ date_to: e.target.value })} data-testid={`${testId}-date-to`} />
        </div>
      ) : period === "BULANAN" ? (
        <Select value={date.slice(0, 7)} onValueChange={(m) => set({ date: `${m}-01` })}>
          <SelectTrigger className="w-44" data-testid={`${testId}-month`}><SelectValue /></SelectTrigger>
          <SelectContent>{months.map((m) => <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>)}</SelectContent>
        </Select>
      ) : period === "TAHUNAN" ? (
        <Select value={date.slice(0, 4)} onValueChange={(y) => set({ date: `${y}-01-01` })}>
          <SelectTrigger className="w-32 h-9" data-testid={`${testId}-year`}><SelectValue /></SelectTrigger>
          <SelectContent>{years.map((y) => <SelectItem key={y} value={y}>{y}</SelectItem>)}</SelectContent>
        </Select>
      ) : (
        <div className="flex items-center gap-2">
          <Input type="date" className="w-40 h-9" value={date} onChange={(e) => e.target.value && set({ date: e.target.value })} data-testid={`${testId}-date`} />
          {period === "MINGGUAN" && <span className="text-xs text-slate-500" data-testid={`${testId}-week-range`}>Sen {weekRange(date)[0]} – Min {weekRange(date)[1]}</span>}
        </div>
      )}
    </div>
  );
}
